var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-wrapper",on:{"click":function($event){return _vm.$emit('action')}}},[_c('svg',{attrs:{"fill":_vm.color,"width":_vm.width,"height":_vm.height}},[_c('use',_vm._b({},'use',{
        'xlink:href': require('@/assets/feather-sprite.svg') + '#' + _vm.name,
      },false))]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }